import { Label } from "../label";
import { useRadio, UseRadioProps } from "./use-radio";

export type RadioProps = UseRadioProps;

export const Radio = (props: RadioProps) => {
  const { className, styles, fieldId, label, color, componentProps } =
    useRadio(props);

  return (
    <div className={styles.base({ className })}>
      <div className={styles.group()}>
        <input
          id={fieldId}
          className={styles.input()}
          {...componentProps}
          type="radio"
        />
        {!!label && (
          <Label htmlFor={fieldId} color={color} className={styles.label()}>
            {label}
          </Label>
        )}
      </div>
    </div>
  );
};
